module.exports = __webpack_public_path__ + "img/bento-header.12fd1c2b.png";